import { onDocumentLoaded } from "./helpers/utils"

const getNumberOfColumns = () => (window.innerWidth < 961 ? 2 : 3) // 960px is 3x the minimum supported size

const getGridItemClassName = (index, numberOfGridItems) => {
  const numberOfColumns = getNumberOfColumns()
  const remainder = numberOfGridItems % numberOfColumns

  switch (true) {
    case remainder === 0:
      return "voyage__grid-item--in-" + numberOfColumns + "-column-layout"

    case remainder === 1 && index === 0 && window.innerWidth > 739:
      return "voyage__grid-item--in-1-column-layout"

    case remainder === 2 && [0, 1].includes(index):
      return "voyage__grid-item--in-" + remainder + "-column-layout"

    default:
      return "voyage__grid-item--in-" + numberOfColumns + "-column-layout"
  }
}

const getInsightsMostRecentGridItemClassName = (index, numberOfGridItems) => {
  const numberOfColumns = 3
  var everyThird = (index + 1) % numberOfColumns
  var currentRow = Math.ceil((index + 1) / numberOfColumns)
  var evenRow = currentRow % 2

  switch (true) {
    case window.innerWidth <= 739:
      return "voyage__grid-item--in-" + numberOfColumns + "-column-layout"

    case everyThird === 1 && evenRow === 1:
      return "voyage__grid-item--in-" + 1 + "-column-layout"

    case everyThird === 2 && evenRow === 1:
      return "voyage__grid-item--in-" + 2 + "-column-layout"

    case everyThird === 0 && evenRow === 1:
      return "voyage__grid-item--in-" + 2 + "-column-layout"

    case evenRow === 0:
      return "voyage__grid-item--in-" + numberOfColumns + "-column-layout"

    default:
      return "voyage__grid-item--in-" + numberOfColumns + "-column-layout"
  }
}

function voyageGridItemClassUpdater(grids) {
  Array.prototype.forEach.call(grids, (gridNode) => {
    const gridItems = Array.from(gridNode.children).filter(function (g) {
      return g.className.indexOf("do-not-show") < 0
    })

    Array.prototype.forEach.call(gridItems, (gridItem, index) => {
      gridItem.className =
        "voyage__grid--item-wrapper " +
        getGridItemClassName(index, gridItems.length)
    })
  })
}

function voyageInsightsMostRecentGridsItemClassUpdater(grids) {
  Array.prototype.forEach.call(grids, (gridNode) => {
    const gridItems = Array.from(gridNode.children).filter(function (g) {
      return g.className.indexOf("do-not-show") < 0
    })

    Array.prototype.forEach.call(gridItems, (gridItem, index) => {
      gridItem.className =
        "voyage__grid--item-wrapper " +
        getInsightsMostRecentGridItemClassName(index, gridItems.length)
    })
  })
}

const getSimpleGridItemClassName = () => {
  const numberOfColumns = getNumberOfColumns()
  return `voyage__simple-grid-item--in-${numberOfColumns}-column-layout`
}

function voyageSimpleGridItemClassUpdater(simpleGrids) {
  simpleGrids.forEach((gridNode) => {
    const gridItems = Array.prototype.slice.call(gridNode.children)

    gridItems.forEach((gridItem) => {
      gridItem.className = getSimpleGridItemClassName()
    })
  })
}

const addEventListeners = () => {
  const grids =
    document.querySelectorAll(
      "div[class='voyage__grid-container--grid-items']"
    ) || []
  const voyageInsightsMostRecentGrids =
    document.querySelectorAll(
      ".voyage-most-recent .voyage__grid-container--related-content-grid-items"
    ) || []
  const simpleGrids =
    document.querySelectorAll(
      "div[class='voyage__grid-container--simple-grid-items']"
    ) || []
  const relatedContentGrids =
    document.querySelectorAll(
      "div[class='voyage__grid-container--related-content-grid-items']"
    ) || []

  voyageGridItemClassUpdater(grids)
  voyageInsightsMostRecentGridsItemClassUpdater(voyageInsightsMostRecentGrids)
  voyageSimpleGridItemClassUpdater(simpleGrids)

  window.addEventListener("resize", () => {
    voyageGridItemClassUpdater(grids)
    voyageInsightsMostRecentGridsItemClassUpdater(voyageInsightsMostRecentGrids)
    voyageSimpleGridItemClassUpdater(simpleGrids)
  })
}

export default () => onDocumentLoaded(addEventListeners)
